<template>
  <div id="mission">
    <NavBar :mainPage="mainPage" color="white" />
    <section id="mission-header" class="fullpage missionin" ref="aboutstart">
      <Missionintro :heading="headings.first" :paragraphs="paragraphs" />
    </section>
    <section id="mission-timeline" class="mission-timeline fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="timeline-head">Our Timeline</div>
      </div>
      <div class="timeline-mid-section">
      <Timelinetest class="timeline-main-carousel" :timelinedata="timeline" :heading="headings.second" />
      </div>
    </section>
    <section id="mission-people" class="mission-people fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="people-head">Our People</div>
      </div>
      <div class="our-people-mid-section">
      <Ourpeople class="our-people" :heading="headings.third" :owners="Owners" :persons="persons" />
      </div>
    </section>
    <section id="foot" class="fullpage" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>
<script>
import Ourpeople from "./our-people";
import Missionintro from "./mission-intro";
import Timelinetest from "./timeline-test";

export default {
  name: "Mission",
  components: {
    Missionintro,
    Ourpeople,
    Timelinetest,
  },
  data() {
    return {
         inMove: false,
        activeSection: 0,
        offsets: [],
        touchStartY: 0,
         positionVisibility:true,
         mainPage: true,
         headings:{
            first:"Our Mission is to Empower SMEs Financially ",
            second:"Our Timeline",
            third:"Our People"
        },
        paragraphs:{
            first:"ftcash is one of India’s leading financial technology company that empowers micro-merchants and small businesses by bridging the lending gap with accessible loans.",
            // second:"We offer loan issuance with minimal documentation and easy repayment options. To take off the pressure of paying loans, we at ftcash have introduced EDI (Equated Daily Installments) that lets the borrowers repay in easy and small amounts daily. ",
            second:"Additionally, the ftcash app and the PoS machine helps small merchants to tap the power of digital payments. With easy access to credit and digital payment solutions, we strive to uplift every small business owner in India."
        },
        Owners: [
        {
          image: 'sanjeev_sir.jpg',
          name: 'Sanjeev Chandak',
          position:'CEO',
          description: 'Strong experience in leveraging data and AI/ML based credit risk models to enable sub-prime lending across US and India'
        },
        {
          image: 'deepak_sir.jpg',
          name: 'Deepak Kothari',
          position:'COO',
          description: 'Varied experience leading teams on consulting projects in the financial services space. Deep understanding of operational effectiveness'
        },
        {
          image: 'vaibhav_sir.jpg',
          name: 'Vaibhav Lodha',
          position:'CBO',
          description: 'Strong experience in building a sales and marketing function in various organizations'
        }
        ],
       loanSteps:[
         {
          heading:"Easy steps to getting a secured business loan",
          stepno: 'Step 1',
          info:'Check eligibility and collateral requirements',
          className: 'loanStep1',
          bgImage:'stepsbg1.png'
        },
        {
          heading:"Easy steps to getting a secured business loan",
          stepno: 'Step 2',
          info:'Apply with KYC documents and collateral security proof',
           className: 'loanStep2',
          bgImage:'stepsbg2.png'
        },
        {
          heading:"Easy steps to getting a secured business loan",
          stepno: 'Step 3',
          info:'Verification by the team',
           className: 'loanStep3',
          bgImage:'stepsbg3.png'
        },
        {
          heading:"Easy steps to getting a secured business loan",
          stepno: 'Step 4',
          info:'Loan Disbursed!',
           className: 'loanStep4',
          bgImage:'stepsbg4.png'
        }
       ],
       persons:[
           {
              image:"sanjeev_sir.jpg",
              name: 'Sanjeev Chandak',
              position:'CEO',
              linkedin_Url:'https://in.linkedin.com/in/sanjeevchandak',
              description: 'Strong experience in leveraging data and AI/ML based credit risk models to enable sub-prime lending across US and India',
              logos:[
                {
                  logo:'deutache.png',
                  visit_url:'#'
                },
                {
                  logo:'capital_one.png',
                  visit_url:'#'
                },
                {
                  logo:'Wharton.png',
                  visit_url:'#'
                },
              ]
              
           },
            {
              image:"deepak_sir.jpg",
              name: 'Deepak Kothari',
              position:'COO',
              linkedin_Url:'https://in.linkedin.com/in/kotharideepak?trk=public_profile_browsemap_profile-result-card_result-card_full-click',
              description: 'Varied experience in leading teams on consulting projects in the financial services space. Deep understanding of operational effectiveness',
              logos:[
                {
                  logo:'grant_thorton.png',
                  visit_url:'#'
                },
                {
                  logo:'kpmg.png',
                  visit_url:'#'
                },
                {
                  logo:'college.png',
                  visit_url:'#'
                },
              ]
            },
            {
              image:"vaibhav_sir.jpg",
              name: 'Vaibhav Lodha',
              position:'CBO',
              linkedin_Url:'https://in.linkedin.com/in/vaibhavlodha',
              description: 'Strong experience in building sales and marketing verticals function in various organizations',
              logos:[
                {
                  logo:'lgt.png',
                  visit_url:'#'
                },
                {
                  logo:'world_bank.png',
                  visit_url:'#'
                },
                {
                  logo:'harvard.png',
                  visit_url:'#'
                },
              ]
            },

       ],
       timeline:[
         {
           position:"up",
           date:"2015",
           description:"ftcash was launched with a dream to empower small businesses and micro-merchants"
         },
         {
           position:"down",
           date:"2015",
           description:"Made it to the PayPal’s Top 4 FinTech Startups for Start Tank India Incubator Programme"
         },
         {
           position:"up",
           date:"2016",
           description:"Launched UPI for merchants in association with ICICI Bank"
         },
         {
           position:"down",
           date:"2016-2018",
           description:"Many more accolades to our hat with Great Tech Rocketships Initiative Award, NASSCOM Emerge Award’16 and Audience Award at NTT Data Open Innovation Award’18. "
         },
         {
           position:"up",
           date:"2019",
           description:"Raised ₹ 50 crores from two investors – 1. Dutch development finance institution FMO 2. Accion International, a US-based non-profit investor focused on fintech start-ups "
         },
         {
           position:"down",
           date:"2019",
           description:"ftcash spreads its wings to Hyderabad, Indore and Ahmedabad"
         },
         {
           position:"up",
           date:"2019",
           description:"Started working with Facebook"
         },
        


       ]

    }
  },
  
  mounted() {
    
     this.$refs.aboutstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
     //window.scrollTo(0, 0);
  },
  metaInfo() {
    return{
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "We are amongst the best business loan companies in India. Our aim to empower SMEs financially with our customised business loans. Visit ftcash to know more!"
        }
      ],
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/about' },
    ],
    }
  },
};
</script>
<style scoped>
body {
  height: auto;
  line-height: 1.6;
  overflow: auto;
}
#mission {
  overflow-y: hidden;
}

.missionin{
  background-image: linear-gradient(rgb(117 117 117 / 33%), rgb(0 0 0 / 78%)),url("../../assets/background/mission_bg.jpg");
  /*background-image: linear-gradient(rgb(82 61 61 / 33%), rgb(0 0 0 / 78%)),url("../../assets/background/mission_bg.jpg");
  background-image: linear-gradient(rgba(0, 0, 0, 0.33), rgba(0, 0, 0, 0.78)),url("../../assets/background/mission_bg.jpg"); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
.awards-img {
  right: 0;
  z-index: -1;
}
.our-people{
  margin-top:5rem;
  padding-bottom:80px;
}
	.mission-timeline, .mission-people {
  position: relative;
  }
.features-image-bg {
   width: 92px;
  height: 114px;
  float: right;
}
  .timeline-head {
       font-size: 3.3rem;
    position: absolute;
    right: 59px;
    float: right;
    z-index: 2;
    top: 47px;
}
/* Our People */
.people-head {
       font-size: 3.3rem;
    position: absolute;
    right: 58px;
    float: right;
    z-index: 2;
    top: 46px;
}

.awards-main-section {
  margin-top:7rem;
}
.awards-title-section {
  width: 100vw;
  min-height: 114px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  /*position: absolute;
  top: 0;*/
  z-index: -2;
}
.award-title {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
  float: right;
}
.color_white {
  color: white;
}

/* Mid Sections*/
.timeline-mid-section{
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;

}
.our-people-mid-section{
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}


@media (max-width: 767px) {
  /*
  #mission-timeline {
    display: none !important;
  } */
  .missionin{
  background-size: cover;
  background-position: 65% 50%;
}
.features-image-bg {
  width: 180px;
  height: 58px;
  float: right;
}
.timeline-head {
  font-size: 3.3rem;
  position: absolute;
  right: 150px;
}
/* Our People */
.people-head {
  font-size: 3.3rem;
  bottom: -20%;
  position: absolute;
  right: 150px;
}
.our-people {
  margin: 60px 0 0 0;
}

.awards-main-section {
  margin-top:7rem;
}
.awards-title-section {
  width: 100vw;
  min-height: 58px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  position: absolute;
  top: 0;
}
.award-title {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
  float: right;
}
.color_white {
  color: white;
}
.our-people{
  margin-top:0;
}
}
/* Tablet Screens */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .features-image-bg {
    width: 90px;
    height: 114px;
    float: right;
  }
  .timeline-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  /* Our People */
  .people-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  .awards-main-section {
    margin-top:7rem;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 114px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
     z-index: -2;
  }
  .our-people {
    margin-top: 4rem;
  }
}
/* Mobile Screens */
@media (min-width: 481px) and (max-width: 767px) {
  /*
  #mission-timeline {
    display: none !important;
  } */
  .missionin {
    background-size: cover;
    background-position: 65% 50%;
  }
  .mid {
    padding: 10% 0;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .timeline-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Our People */
  .people-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .our-people {
    margin: 0;
  }
  .awards-main-section {
    margin-top:7rem;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .timeline-main-carousel{
  margin-top:45px;
}
}

@media (max-width: 480px) {
  .missionin {
    background-size: cover;
    background-position: 65% 50%;
  }
  .mid {
    padding: 10% 0;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .timeline-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Our People */
  .people-head {
   font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .our-people {
    margin: 0;
  }
  .awards-main-section {
    margin-top:7rem;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .our-people{
  margin-top:0;
}
.timeline-main-carousel{
  margin-top:45px;
}
}
</style>